import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'katex/dist/katex.min.css';

import './styles/index.scss';
// import './assets/preview.css';
import permission from './directives/permission';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.directive('permission', permission);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

